(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    (function () {
    var detectedCountry = null;

    function applyPolicyVisibility(country) {
      var normalizedCountry = String(country || '').toUpperCase();

      document.querySelectorAll('.wc-show-only-in-israel').forEach(function (element) {
        element.style.display = normalizedCountry === 'IL' ? '' : 'none';
      });
    }

    function detectVisitorCountry() {
      var root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      var url =
        root +
        'browsing_context_suggestions.json' +
        '?country[enabled]=true&country[exclude]=IL';

      /*
       * Hidden by default.
       * Show only after Shopify detects Israel.
       */
      applyPolicyVisibility('');

      fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Country detection request failed');
          }

          return response.json();
        })
        .then(function (data) {
          detectedCountry =
            data &&
            data.detected_values &&
            data.detected_values.country &&
            data.detected_values.country.handle
              ? String(data.detected_values.country.handle).toUpperCase()
              : '';

          applyPolicyVisibility(detectedCountry);
        })
        .catch(function () {
          detectedCountry = '';
          applyPolicyVisibility('');
        });
    }

    function refreshPolicyVisibility() {
      if (detectedCountry !== null) {
        applyPolicyVisibility(detectedCountry);
        return;
      }

      detectVisitorCountry();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refreshPolicyVisibility);
    } else {
      refreshPolicyVisibility();
    }

    window.addEventListener('pageshow', refreshPolicyVisibility);
    document.addEventListener('shopify:section:load', refreshPolicyVisibility);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.querySelector('#wc-balance-policy-modal');
    const frame = document.querySelector('#wc-balance-policy-frame');
    const title = document.querySelector('#wc-balance-policy-title');

    function closePolicy() {
      if (!modal) return;
      modal.hidden = true;
      if (frame) frame.src = '';
      document.body.style.overflow = '';
    }

    document.addEventListener('click', (event) => {
      const policyLink = event.target.closest('.wc-balance-policy-menu__policy-link');
      if (!policyLink || !modal || !frame || !title) return;

      event.preventDefault();
      title.textContent = policyLink.dataset.policyTitle || 'Policy';
      frame.src = policyLink.dataset.policyUrl;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('.wc-balance-policy-modal__close')) closePolicy();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePolicy();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
